import { useState, useEffect } from 'react'
import { checkProductAvailability } from './utils'

export const usePackAvailability = (settings, packProducts, stock) => {
  const [soldOut, setIsSoldOut] = useState(false)

  useEffect(() => {
    if (
      settings &&
      typeof packProducts !== undefined &&
      packProducts?.length > 0
    ) {
      const packAvailability: any = []
      packProducts?.forEach((packProduct) => {
        let isAvailable = 'ko'
        isAvailable = checkProductAvailability(stock, packProduct.product)
          .available
          ? 'ok'
          : 'ko'
        packAvailability.push(isAvailable)
      })
      setIsSoldOut(packAvailability.includes('ko'))
    }
  }, [packProducts, stock])

  return {
    soldOut,
  }
}
